import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLazyQuery } from '@apollo/react-hooks';
import styled from 'styled-components';
import { toast } from 'react-toastify';

import { updateLoansState } from '../../actions';
import useActions from '../../utils/useActions';
import { getLoansGQL } from '../../apollo';
import ReactTable from '../ReactTable';
import columns from './columns';
import SubRow from './SubRow';
import RefreshButton from '../RefreshButton';
import { Title, TotalEntries, TitleContainer } from '../TableStyles';

const TitleItems = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const LoansTable = () => {
  const state = useSelector(({ loans }) => ({ loans }));
  const loanTableColumns = React.useMemo(() => columns, []);
  const [updateLogs] = useActions([updateLoansState]);
  const [getLoans] = useLazyQuery(getLoansGQL, {
    onCompleted: ({ getLoans: result }) => {
      updateLogs(result);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [refreshLoans] = useLazyQuery(getLoansGQL, {
    onCompleted: ({ getLoans: result }) => {
      updateLogs(result);
      toast.success('Loan table refreshed', {
        position: toast.POSITION.TOP_RIGHT,
      });
    },
    onError: (e) => {
      console.log(e);
      toast.warn('Loan table not refreshed. Please reload page.', {
        position: toast.POSITION.TOP_RIGHT,
      });
    },
  });

  useEffect(() => {
    getLoans();
  }, []);

  return (
    <section>
      <div>
        <TitleContainer>
          <TitleItems>
            <Title>Loans</Title>
            <TotalEntries>{state.loans.length}</TotalEntries>
          </TitleItems>
          <ButtonContainer>
            <RefreshButton refreshList={refreshLoans} />
          </ButtonContainer>
        </TitleContainer>
        <ReactTable
          data={state.loans}
          columns={loanTableColumns}
          SubRow={SubRow}
        />
      </div>
    </section>
  );
};

export default LoansTable;
